import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Identity } from '@rivethealth/data/auth';
import { ROUTER_API_URL } from './common';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    @Inject(ROUTER_API_URL) private readonly routerUrl: string,
    private readonly http: HttpClient,
  ) {}

  getIdentity() {
    return this.http.get<Identity>(`${this.routerUrl}/auth/identity`);
  }

  systemLogin(user: { email: string; name: string }) {
    return this.http.post<string>(`${this.routerUrl}/auth/system-login`, user);
  }

  sendSSOEmail(email: string) {
    return this.http.post<{ url: string }>(`${this.routerUrl}/auth/sso-email`, {
      email,
    });
  }

  sendAllLoginsEmail(email: string) {
    return this.http.post<{ url: string }>(
      `${this.routerUrl}/auth/login-email`,
      {
        email,
      },
    );
  }
}
